export default __webpack_public_path__ + "static/media/team4.0da8bbf9.jpeg";